<template>
	<v-container align-center class="d-flex" pa-2>
		<v-checkbox
			v-bind:label="layer.service.title"
			v-model="visible"
			dense
			hide-details
			class="ma-0 pa-0"
		></v-checkbox>
		<v-btn
			icon
			v-on:click="showSettings(layer)"
			class="ml-1"
		>
			<v-icon
				size="16"
				title="Nustatymai"
			>
				mdi-cog
			</v-icon>
		</v-btn>
	</v-container>
</template>

<script>
	export default {
		props: {
			layer: Object,
			showSettings: Function
		},
		data: function(){
			var data = {
				visible: this.layer.get("visible")
			};
			return data;
		},
		watch: {
			visible: {
				immediate: true,
				handler: function(newValue){
					this.layer.set("visible", newValue);
				}
			}
		}
	}
</script>

<style scoped>
	.container {
		border: 1px solid #eaeaea;
		background-color: #f9f9f9;
	}
</style>